namespace TabAurous.Retail {
    export namespace POSReturnService {
        export const baseUrl = 'Retail/POSReturn';

        export declare function Create(request: Serenity.SaveRequest<POSReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: Purchase.GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSReturn/Create",
            Update = "Retail/POSReturn/Update",
            Delete = "Retail/POSReturn/Delete",
            Retrieve = "Retail/POSReturn/Retrieve",
            List = "Retail/POSReturn/List",
            GetLineNo = "Retail/POSReturn/GetLineNo"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo'
        ].forEach(x => {
            (<any>POSReturnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
